export { PartnerDetails } from './partner-details';